module.exports = __webpack_public_path__ + "static/media/244-south-sudan.e68bb216.svg";